import React from 'react';
import { getRetailers, saveLocation, saveRetailer } from '../data/serviceLeadgen';
import { hideMessage, showMessage } from '../helpers/uiFunctions/uiActions';
import NfaExplorer from './NfaExplorer/Explorer';
import NfaProfile from './NfaProfile/Profile';

class NFA extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
			dealers: [],
			currentRetailer: null,
		}
		this.loadRetailer = this.loadRetailer.bind(this);
		this.resetProfile = this.resetProfile.bind(this);
		this.updateRetailer = this.updateRetailer.bind(this);
		this.updateLocation = this.updateLocation.bind(this);
		this.saveRetailer = this.saveRetailer.bind(this);
		this.saveLocations = this.saveLocations.bind(this);
	}
    componentDidMount() {
        getRetailers("nfa", localStorage.getItem("token")).then(response => {
            if (response.length > 0) {
                this.setState({ dealers: response });
            }
        });
	}
	resetProfile() {
		this.setState({ currentRetailer: null, });
	}
    loadRetailer(id) {
		var retailer = this.state.dealers.filter(obj => {
			return obj.retailerCode === id;
		});
		this.setState({ currentRetailer: retailer[0], });
		document.querySelectorAll("#nfa-profile-column .profile")[0].style.display = "block";
	}
	updateRetailer(key, value) {
		this.setState(state => {
			state.currentRetailer[key] = value;
			return state;
		});
	}
	updateLocation(index, key, value) {
		this.setState(state => {
			state.currentRetailer.locations[index][key] = value;
			return state;
		});
	}
	saveRetailer() {
		var retailer = this.state.currentRetailer;
		showMessage("Saving Retailer...");
		console.log(retailer);
		saveRetailer(retailer).then(response => {
			console.log(response);
			if (response.success) {
				hideMessage(response.success);
			}
		});
	}
	saveLocations() {
		var locations = this.state.currentRetailer.locations;
		showMessage("Saving Locations...");
		for (let i = 0; i < locations.length; i++) {
			saveLocation(locations[i]).then(response => {
				console.log(response);
				if (response.success) {
					hideMessage(response.success);
				}
			});
		}
	}
    render() {
        return(
            <div className="columns">
                <NfaExplorer data={this.state} load={this.loadRetailer} resetProfile={this.resetProfile} />
                <NfaProfile
					retailer={this.state.currentRetailer}
					updateRetailer={this.updateRetailer}
					updateLocation={this.updateLocation}
					saveRetailer={this.saveRetailer}
					saveLocations={this.saveLocations}
				/>
            </div>
        )
    }
}
export default NFA;


// WEBPACK FOOTER //
// ./src/component_nfa/NfaTool.js